import axios from 'axios';

import { API_ENDPOINT } from '../../../index';

export const getAccountsToVerify = ( verifyType:string ) => axios({
	url: `${API_ENDPOINT}/api/admin/users/unverified/${verifyType}`,
	withCredentials: true
})


// WEBPACK FOOTER //
// ./src/components/verification/actions/index.js